(() => {
  'use strict';
  if (window.__SQ_PDP_CARD_REFINEMENT_V1__) return;
  window.__SQ_PDP_CARD_REFINEMENT_V1__ = true;

  const WORLD = '.sq-product-world';
  const CARD = '.sq-product-card';

  const productHref = card => card?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '#';

  function refineCard(card) {
    if (!(card instanceof Element) || !card.matches(CARD)) return;
    const body = card.querySelector('.sq-product-card__body');
    if (!body) return;

    let action = [...body.children].find(node => node instanceof HTMLAnchorElement && node.classList.contains('sq-chip'));
    if (!action) {
      action = document.createElement('a');
      action.className = 'sq-chip';
      action.href = productHref(card);
      body.appendChild(action);
    }
    action.textContent = 'View these pieces';
    action.setAttribute('aria-label', `View ${String(card.querySelector('h3')?.textContent || 'this piece').trim()}`);
  }

  function refine(root = document) {
    const worlds = [];
    if (root instanceof Element && root.matches(WORLD)) worlds.push(root);
    root.querySelectorAll?.(WORLD).forEach(node => worlds.push(node));

    worlds.forEach(world => {
      world.querySelectorAll(CARD).forEach(refineCard);
      if (world.dataset.sqPdpRefinementObserved === 'true') return;
      world.dataset.sqPdpRefinementObserved = 'true';
      new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches(CARD)) refineCard(node);
          node.querySelectorAll?.(CARD).forEach(refineCard);
        }));
      }).observe(world, {childList:true, subtree:true});
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => refine(document), {once:true})
    : refine(document);
  document.addEventListener('shopify:section:load', event => refine(event.target));
})();
